import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationInput } from '../../../../types/schema/utils.types';
import { User } from '../../../../types/schema/user.types';

interface GetAllUserContentsNeedApprovalHook {
  data: User[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllUserContentsNeedApproval: User[];
    }>
  >;
}

interface UseGetAllUserContentsNeedApprovalMutationData {
  getAllUserContentsNeedApproval: User[];
}

interface UseGetAllUserContentsNeedApprovalInputType {
  input: PaginationInput;
}

export function useGetAllUserContentsNeedApproval(
  query: DocumentNode,
  input: PaginationInput
): GetAllUserContentsNeedApprovalHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    UseGetAllUserContentsNeedApprovalMutationData,
    UseGetAllUserContentsNeedApprovalInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllUserContentsNeedApproval,
    loading,
    error,
    refetch,
  };
}
